import { Controller } from "@hotwired/stimulus"

// Debounced auto-submit for the docs search combobox. Keeping the
// form a plain GET means JS-disabled operators can still submit by
// pressing Enter; this controller just shaves the time-to-results
// when JS is on.
export default class extends Controller {
  static targets = ["form", "input"]

  static values = { delay: { type: Number, default: 300 } }

  initialize() {
    this.timer = null
  }

  queue() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(() => {
      if (this.hasFormTarget) this.formTarget.requestSubmit()
    }, this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
